import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { session } from '@/lib/session';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState(
    session.hasAccess() ? 'ok' : 'checking'
  );

  useEffect(() => {
    if (authState !== 'checking') return;

    axios
      .get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true })
      .then(({ data }) => {
        session.hydrate(data);
        setAuthState('ok');
      })
      .catch(() => {
        session.clearAll();
        setAuthState('denied');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (authState === 'checking') return null;
  if (authState === 'denied') return <Navigate to="/login" replace />;
  return children;
}
